import { render, staticRenderFns } from "./ServerSettings.vue?vue&type=template&id=37666430&scoped=true&lang=pug&"
import script from "./ServerSettings.vue?vue&type=script&lang=js&"
export * from "./ServerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37666430",
  null
  
)

export default component.exports